import { ref, onMounted } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'

export default function useAvailableDrafts() {
  const options = ref([])
  const loading = ref(false)

  async function fetch() {
    loading.value = true
    try {
      const res = await draftApi.availableForSetup()
      options.value = res.data.data
    } finally {
      loading.value = false
    }
  }

  onMounted(fetch)

  return { options, loading }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useAvailableDrafts.js